export * from './record-data.component';



// WEBPACK FOOTER //
// ./src/app/components/record-data/index.ts